// extracted by mini-css-extract-plugin
export default {"team_content":"Team_team_content__ZnlYl","h2":"Team_h2__CnIRZ","subtitle":"Team_subtitle__-HlqM","team_members":"Team_team_members__FH54C","management":"Team_management__Iw2oR"};